export default __webpack_public_path__ + "static/media/marketing_services-dk.98f9b0cf.svg";